<template>
    <div v-if="post" class="left">

        <div class="na-form">
            <div class="dx-fieldset">
                <div class="dx-field">
                    <div class="dx-field-label">id:</div>
                    <div class="dx-field-value">
                        <DxTextBox :value='post.AffID' :readOnly="true" />
                    </div>

                </div>
                <div class="dx-field">
                    <div class="dx-field-label">{{tx.FieldName}}:</div>
                    <div class="dx-field-value">
                        <DxTextBox v-model:value='post.AffName' />
                    </div>

                </div>
                <div class="dx-field">
                    <div class="dx-field-label">{{tx.FieldShortName}}:</div>
                    <div class="dx-field-value">
                        <DxTextBox v-model:value='post.AffShortName' />
                    </div>

                </div>

                <div class="dx-field">
                    <div class="dx-field-label">{{tx.FieldCreatedBy}}:</div>
                    <div class="dx-field-value">
                        <DxTextBox :value='post.AffCreatedBy' :readOnly="true" />
                    </div>
                </div>

                <div class="dx-field">
                    <div class="dx-field-label">{{tx.FieldCreatedOn}}:</div>
                    <div class="dx-field-value">
                        <DxDateBox :value='post.AffCreatedOn' :readOnly="true" />
                    </div>

                </div>
                <div class="dx-field">
                    <div class="dx-field-label">{{tx.FieldChangedBy}}:</div>
                    <div class="dx-field-value">
                        <DxTextBox :value='post.AffChangedBy' :readOnly="true" />
                    </div>
                </div>

                <div class="dx-field">
                    <div class="dx-field-label">{{tx.FieldChangedOn}}:</div>
                    <div class="dx-field-value">
                        <DxDateBox :value='post.AffChangedOn' :readOnly="true"/>
                    </div>

                </div>

                <div class="na-buttons-row">

                    <div>
                        <DxButton 
                                  :text="btn.BtnSave"
                                  type="default"
                                  styling-mode="contained"
                                  @click="onSaveClick()"
                                  onmouseover="this.style.backgroundColor='#006db9'" />
                    </div> 
                    <div>
                        <DxButton 
                                  :text="btn.BtnDelete"
                                  type="default"
                                  styling-mode="contained"
                                  @click="onDeleteClick()"
                                  onmouseover="this.style.backgroundColor='#006db9'" />
                    </div>
                    <div>
                        <DxButton 
                                  :text="btn.BtnCancel"
                                  type="default"
                                  styling-mode="outlined"
                                  @click="onCloseClick()" />
                    </div>
                    <div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    // @ is an alias to /src
    import { confirm, alert } from "devextreme/ui/dialog";
    import { DxTextBox } from 'devextreme-vue';
    import { DxButton } from 'devextreme-vue/button';
    import notify from 'devextreme/ui/notify';
    import { DxDateBox } from 'devextreme-vue/date-box';
    import '../assets/detailForm.less';
    import $ from 'jquery';
    const baseUri = "WebApi.asmx/api/affiliationService";
    export default {
        name: 'AffiliationDetail',
        components: {

            DxButton,
            DxTextBox,
            DxDateBox,

        },
        data() {
            return {
                post: null,
                tx: {
                    FieldName: this.$LanguageProvider.GetResource("FieldName", "Caption", "Name"),
                    FieldShortName: this.$LanguageProvider.GetResource("FieldShortName", "Caption", "Kurzname"),
                    FieldCreatedBy: this.$LanguageProvider.GetResource("FieldCreatedBy", "Caption", "Erstellt von"),
                    FieldCreatedOn: this.$LanguageProvider.GetResource("FieldCreatedOn", "Caption", "Erstellt am"),
                    FieldChangedOn: this.$LanguageProvider.GetResource("FieldChangedOn", "Caption", "Geändert am"),
                    FieldChangedBy: this.$LanguageProvider.GetResource("FieldChangedBy", "Caption", "Geändert von"),
                },
                btn: {
                    BtnSave: this.$LanguageProvider.GetResource("BtnSave", "Caption", "Speichern"),
                    BtnDelete: this.$LanguageProvider.GetResource("BtnDelete", "Caption", "Löschen"),
                    BtnCancel: this.$LanguageProvider.GetResource("BtnCancel", "Caption", "Abbrechen"),
                }
            };
        },
        created: function () {
            axios
                .get(baseUri + '/GetDetailVx')
                .then(res => {
                    this.post = res.data.data
                })
        },
        methods: {
             onCloseClick() {
                $("form").attr("action", window.location.pathname + "?action=cancel").submit();
            },
            onSaveClick() {
                var formData = new FormData()
                formData.append("data", JSON.stringify(this.post))
                axios
                    .post(baseUri + '/SaveDetail', formData)
                    .then(res => {
                        if (res.data.success) { notify(`The changes were saved successfully`); }
                        else { alert(`error: ${res.data.errorMessage}`) }

                    })

            },
            onDeleteClick() {
                let result = confirm("do you really want to delete this record?", "Confirm delete");
                result.then((dialogResult) => {
                    if (dialogResult) {
                        var formData = new FormData()
                        formData.append("data", JSON.stringify(this.post))
                        axios
                            .post(baseUri + '/Delete', formData)
                            .then(res => {
                                if (res.data.success) {
                                    notify(`The record has been successfully deleted`);
                                    $("form").attr("action", window.location.pathname + "?action=cancel").submit();
                                }
                                else { alert(`error: ${res.data.errorMessage}`) }

                            })
                    }


                });


            },
            capitalize(text) {
                return text.charAt(0).toUpperCase() + text.slice(1);
            }
        }
    }


</script>
<style>

 
</style>
